import { Grid } from "@material-ui/core";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Image } from "react-bootstrap";
import { getEmergencySetting } from "../../../../api/emergencySettingApi";
import { toImageUrl } from "../../../../utils/formatHelper";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export default function ContentR({ objectMaps }) {
    const [stateFile, setStateFile] = useState(null);
    // ref
    const controllerRef = useRef(null);
    const fetchData = useCallback(async () => {
        try {
            const res = await getEmergencySetting(controllerRef.current?.signal);
            if (res) {
                setStateFile(
                    res?.image
                        ? {
                              name: "",
                              src: toImageUrl(res?.image),
                          }
                        : null,
                );
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // run only first render
    useEffect(() => {
        fetchData();
        controllerRef.current = new AbortController();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, [fetchData]);
    return (
        <Grid container spacing={0}>
            {stateFile !== null ? (
                <Grid item xs={12}>
                    <div className="d-flex justify-content-center align-align-items-center h-100 w-100 ">
                        <Image src={stateFile?.src} className="img-fluid" />
                    </div>
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <div className="d-flex justify-content-center align-align-items-center h-100 w-100 ">
                        <Image src={toAbsoluteUrl("/media/HCH/imgs/no-image-lg.png")} className="img-fluid w-100 h-100" />
                    </div>
                </Grid>
            )}
        </Grid>
    );
}
